import Provider from './Provider';
import connect from './connect';
import createComponent from './createComponent';
import ThemeProvider from './ThemeProvider';

export { Provider, connect, createComponent, ThemeProvider };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-fela/es/index.js
// module id = 292
// module chunks = 0